import { render, staticRenderFns } from "./AssignRepresentative.vue?vue&type=template&id=aa5d3b5a"
import script from "./AssignRepresentative.vue?vue&type=script&lang=js"
export * from "./AssignRepresentative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports